// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/SourceCodePro-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/SourceCodePro-Italic-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-red {
  color: var(--elem-red-color);
}
.color-green {
  color: green;
}
.color-blue {
  color: var(--toolbtn-active-color);
}
body {
  margin: 0;
  user-select: none;
  overflow-x: hidden;
}
body {
  background-color: var(--bg-color);
  color: var(--font-color);
}
ul {
  padding: 0;
  margin: 0;
}
li {
  display: block;
  width: 100%;
}
.grey {
  background: grey;
}
.green {
  background: green;
}
.red {
  background: var(--elem-red-color);
}
.vert-line {
  width: 1px;
  background: var(--vert-line-color);
}
.hor-line {
  height: 1px;
  background: var(--hor-line-color);
}
.light-line {
  background: var(--message-bg-color2);
}
.dark-line {
  background: #8f8f8f78;
}
.columns-layout {
  position: relative;
  display: flex;
  overflow: hidden;
  height: 100%;
}
.rows-layout {
  position: relative;
  display: flex;
  flex-direction: column;
  height: calc(var(--vh) * 100);
}
.main {
  position: relative;
  flex-grow: 1;
  height: 100%;
}
.row-layout {
  position: relative;
  width: 100%;
  height: 100%;
}
.row-layout > div {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.modalDialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 99999;
  -webkit-transition: opacity 400ms ease-in;
  -moz-transition: opacity 400ms ease-in;
  transition: opacity 400ms ease-in;
  display: none;
  pointer-events: none;
}
.slider {
  display: inline-flex;
  position: relative;
  height: 14px;
  margin: 10px 0;
}
.slider ._slider-cont {
  height: 4px;
  width: 100%;
  margin: auto 0;
  background-color: grey;
  border-radius: 5px;
}
.slider ._slider-cont ._slider-wrapper {
  height: inherit;
  width: 100%;
  background-color: #1e98ff;
  border-radius: inherit;
}
.slider ._slider-cont ._slider-wrapper ._progress {
  margin-left: auto;
  height: inherit;
  background-color: grey;
  border-radius: inherit;
}
.slider ._slider-cont ._slider-wrapper ._thumb {
  display: none;
  height: 8px;
  width: 4px;
  position: absolute;
  border-radius: 5px;
  background-color: var(--elem-red-color);
  transform: translate(0px, -75%);
}
.slider:hover ._slider-cont ._slider-wrapper ._thumb {
  display: block;
}
.section-header {
  display: flex;
  align-items: center;
  height: 60px;
  min-width: 326px;
  background-color: var(--bg-color);
  padding: 5px;
  border-bottom: 1px solid var(--border-bottom-section);
  overflow: hidden;
}
.section-header > * {
  margin: auto 10px;
  overflow: hidden;
}
.section-header .header-back {
  cursor: pointer;
  font-size: 19px;
  display: flex;
  align-items: center;
}
.section-header .header-text {
  font-size: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.section-header .header-user-block {
  display: flex;
  cursor: pointer;
  overflow: hidden;
}
.section-header .header-btns {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: auto;
  font-size: 1.6em;
}
.section-header .header-btns .audio-call {
  margin: auto;
  color: var(--toolbtn-color);
  font-size: 18px;
}
.section-header .header-btns .audio-call:not(.disabled):hover {
  color: #353535;
}
.section-header .header-btns .close-icon {
  height: 18px;
}
#modal {
  position: absolute;
  top: 0;
  z-index: 20;
}
.btn-blue {
  color: #fff;
  background-color: #76a7f3;
  border-color: #6d9ae0;
}
.btn-blue:hover {
  color: #fff;
  background-color: #6d9ae0;
  border-color: #5e86c5;
}
.btn-blue:active {
  color: #fff;
  background-color: #5e86c5;
  border-color: #577ab2;
}
.icon-wrapper .del-item {
  display: inline-block;
}
.switch-group {
  display: flex;
}
.switch-group > label {
  margin: auto 0;
  font-weight: normal;
}
.switch-group > label:first-child {
  margin-right: 15px;
}
.non-border-input {
  width: 90%;
  margin: auto;
  border: none;
  border-radius: 0;
  box-shadow: none !important;
  color: var(--login-color);
  background-color: var(--bgcolor);
  outline: none;
  border-bottom: 1px solid var(--border-bottom-selecteditems);
  padding: 5px 0;
}
.non-border-input:focus {
  border-bottom: 1px solid #2688c2;
}
.div-inout {
  overflow-y: auto;
  max-height: 4em;
}
.div-placeholder {
  color: #999999;
  pointer-events: none;
  padding: 5px 0;
  margin-bottom: -32px;
}
.svg-wrapper {
  display: flex;
}
.fa-phone {
  transform: rotate(90deg);
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #999999 !important;
  opacity: 1;
  /* Firefox */
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #999999 !important;
}
::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #999999 !important;
}
* {
  scrollbar-color: var(--scroll-bar-color) transparent;
  scrollbar-width: thin;
}
*::-webkit-scrollbar {
  width: 14px !important;
}
::-webkit-scrollbar-thumb {
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  -webkit-border-radius: 7px;
  background-color: rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
}
*::-webkit-scrollbar-thumb {
  background-color: var(--scroll-bar-color);
}
::-webkit-scrollbar-corner {
  background: transparent;
}
.chat-mute {
  padding: 0 20px;
}
.chat-mute > p {
  margin-bottom: 20px;
}
.chat-mute form {
  display: flex;
  flex-direction: column;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.modal-content > div {
  border: none;
  padding-left: 20px;
  padding-right: 20px;
}
.modal-content .modal-header {
  background-color: var(--bg-color) !important;
}
.modal-content .modal-header > div {
  margin: auto 0;
}
.visible {
  visibility: visible;
}
.user-profile {
  position: fixed;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  z-index: 1000;
  color: gray;
  font-size: 18px;
  background-color: var(--bg-color);
}
.user-profile .head {
  width: 100%;
  box-shadow: 1px 1px 1px #ccc;
  height: calc(var(--vh) * 7);
  display: flex;
}
.user-profile .head .title {
  margin: auto;
  font-size: 24;
  font-weight: 600;
}
.user-profile .head .close {
  margin: auto 35px auto 0;
}
.user-profile .wrapper {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}
.user-profile .wrapper .left-menu {
  padding: 35px 0 0 28%;
  display: flex;
  text-align: left;
  flex-direction: column;
  width: 40%;
  height: calc(var(--vh) * 93);
  font-weight: initial;
}
.user-profile .wrapper .left-menu .left-menu-group {
  font-weight: bold;
  margin-left: 10px;
  margin-top: 5px;
}
.user-profile .wrapper .left-menu .left-menu-group::not(:first-child) {
  margin-top: 20px;
}
.user-profile .wrapper .left-menu .left-menu-group .group-name {
  display: flex;
  width: 100%;
  padding-left: 10px;
  border-bottom: 1px solid #ddd;
}
.user-profile .wrapper .left-menu .left-menu-group .list-items .item {
  margin: 2px 0;
  padding: 5px 10px;
  border-radius: 10px;
  font-weight: initial;
}
.user-profile .wrapper .left-menu .left-menu-group .list-items .item:hover {
  cursor: pointer;
  background-color: #e5f8ff;
  color: gray;
}
.user-profile .wrapper .left-menu .left-menu-group .list-items .active {
  background-color: var(--blue-bgcolor);
  color: white;
}
.user-profile .wrapper .content {
  padding: 35px 0 35px 10%;
  color: gray;
  display: flex;
  flex-grow: 1;
  height: calc(var(--vh) * 93);
  max-width: 600px;
}
.fade-user-profile-enter-active,
.fade-user-profile-leave-active {
  transition: opacity .3s;
}
.fade-user-profile-enter,
.fade-user-profile-leave-to {
  opacity: 0;
}
.fade-om-journal-enter-active,
.fade-om-journal-leave-active {
  transition: opacity .5s;
}
.fade-om-journal-enter,
.fade-om-journal-leave-to {
  opacity: 0;
}
.datepickers-container {
  z-index: 10000;
}
.om-settings {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.om-settings .login {
  margin: 5px;
}
.om-settings .password {
  margin: 5px;
}
.om-settings .permissions {
  margin: 5px;
}
.om-settings .check {
  width: 50%;
  margin-top: 10px;
  border-radius: 10px;
}
.om-settings .check:hover {
  background-color: lightblue;
}
.v--modal-overlay {
  z-index: 1100 !important;
}
.v--modal {
  -webkit-border-radius: 6px !important;
  -moz-border-radius: 6px !important;
  border-radius: 6px !important;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5) !important;
}
.scroll-msg,
.scroll-pub {
  transition: 0.3s;
}
#notice {
  pointer-events: none;
}
.warning-input {
  border-bottom: 1px solid var(--elem-red-color);
}
.warning-input::placeholder {
  color: var(--elem-red-color) !important;
}
.warning-input:-ms-input-placeholder {
  color: var(--elem-red-color) !important;
}
.warning-input::-ms-input-placeholder {
  color: var(--elem-red-color) !important;
}
.draggable-menu {
  margin: auto 0 auto auto !important;
  width: min-content;
  display: flex;
  font-size: 32px;
  color: var(--custom-textarea-color);
}
.draggable-menu .draggable-move {
  cursor: move;
  margin: auto 10px auto auto;
  font-size: 25px;
}
.draggable-menu .draggable-item-menu {
  cursor: pointer;
  width: 30px;
  height: 100%;
  text-align: center;
}
ul.list li .hor-line {
  width: calc(100% - 68px);
  margin-left: 68px;
}
ul.list li:last-child .hor-line {
  display: none;
}
.flip-list-move {
  transition: transform .5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
#phone {
  height: 100%;
  /* left: 0px; */
}
.transition-phone {
  transition: top 0.6s ease 0.1s;
}
.minimize-phone {
  border-radius: 20px !important;
}
.phone-video-call {
  width: 562px;
  background-color: transparent;
}
#incomming-call {
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  -webkit-box-shadow: 0px 0px 15px 0px rgba(50, 50, 50, 0.75);
  -moz-box-shadow: 0px 0px 15px 0px rgba(50, 50, 50, 0.75);
  box-shadow: 0px 0px 15px 0px rgba(50, 50, 50, 0.75);
  border-radius: 10px;
}
#system-notification {
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  -webkit-box-shadow: 0px 0px 15px 0px rgba(50, 50, 50, 0.75);
  -moz-box-shadow: 0px 0px 15px 0px rgba(50, 50, 50, 0.75);
  box-shadow: 0px 0px 15px 0px rgba(50, 50, 50, 0.75);
  border-radius: 10px;
}
.reference-contact {
  color: var(--ref-link-color);
  cursor: pointer;
}
.reference-contact:hover {
  color: var(--ref-link-color-hover);
  text-decoration: underline;
}
.fa-spinner:not(*:root):before {
  position: relative;
  top: 0.03738em;
}
body.mac .fa-spinner:not(*:root):before {
  top: 0.05em;
}
.item-color-0 {
  color: var(--item-color-0);
}
.item-color-1 {
  color: var(--item-color-1);
}
.item-color-2 {
  color: var(--item-color-2);
}
.item-color-3 {
  color: var(--item-color-3);
}
.item-color-4 {
  color: var(--item-color-4);
}
.item-color-5 {
  color: var(--item-color-5);
}
.item-color-6 {
  color: var(--item-color-6);
}
.item-color-7 {
  color: var(--item-color-7);
}
.item-color-8 {
  color: var(--item-color-8);
}
.item-color-9 {
  color: var(--item-color-9);
}
.item-color-10 {
  color: var(--item-color-10);
}
.item-color-11 {
  color: var(--item-color-11);
}
.item-color-12 {
  color: var(--item-color-12);
}
.item-color-13 {
  color: var(--item-color-13);
}
.item-color-14 {
  color: var(--item-color-14);
}
.item-color-15 {
  color: var(--item-color-15);
}
.item-color-16 {
  color: var(--item-color-16);
}
.item-color-17 {
  color: var(--item-color-17);
}
.item-color-18 {
  color: var(--item-color-18);
}
.item-color-19 {
  color: var(--item-color-19);
}
.item-color-20 {
  color: var(--item-color-20);
}
.item-color-21 {
  color: var(--item-color-21);
}
.item-color-22 {
  color: var(--item-color-22);
}
.item-color-23 {
  color: var(--item-color-23);
}
.item-color-24 {
  color: var(--item-color-24);
}
.item-color-25 {
  color: var(--item-color-25);
}
.item-color-26 {
  color: var(--item-color-26);
}
.item-color-27 {
  color: var(--item-color-27);
}
.item-color-28 {
  color: var(--item-color-28);
}
.item-color-29 {
  color: var(--item-color-29);
}
.item-color-30 {
  color: var(--item-color-30);
}
.item-color-31 {
  color: var(--item-color-31);
}
.item-color-32 {
  color: var(--item-color-32);
}
.item-color-33 {
  color: var(--item-color-33);
}
.item-color-34 {
  color: var(--item-color-34);
}
.item-color-35 {
  color: var(--item-color-35);
}
.item-color-gray {
  color: var(--item-color-gray);
}
.item-bg-color-0 {
  background-color: var(--item-color-0);
}
.item-bg-color-1 {
  background-color: var(--item-color-1);
}
.item-bg-color-2 {
  background-color: var(--item-color-2);
}
.item-bg-color-3 {
  background-color: var(--item-color-3);
}
.item-bg-color-4 {
  background-color: var(--item-color-4);
}
.item-bg-color-5 {
  background-color: var(--item-color-5);
}
.item-bg-color-6 {
  background-color: var(--item-color-6);
}
.item-bg-color-7 {
  background-color: var(--item-color-7);
}
.item-bg-color-8 {
  background-color: var(--item-color-8);
}
.item-bg-color-9 {
  background-color: var(--item-color-9);
}
.item-bg-color-10 {
  background-color: var(--item-color-10);
}
.item-bg-color-11 {
  background-color: var(--item-color-11);
}
.item-bg-color-12 {
  background-color: var(--item-color-12);
}
.item-bg-color-13 {
  background-color: var(--item-color-13);
}
.item-bg-color-14 {
  background-color: var(--item-color-14);
}
.item-bg-color-15 {
  background-color: var(--item-color-15);
}
.item-bg-color-16 {
  background-color: var(--item-color-16);
}
.item-bg-color-17 {
  background-color: var(--item-color-17);
}
.item-bg-color-18 {
  background-color: var(--item-color-18);
}
.item-bg-color-19 {
  background-color: var(--item-color-19);
}
.item-bg-color-20 {
  background-color: var(--item-color-20);
}
.item-bg-color-21 {
  background-color: var(--item-color-21);
}
.item-bg-color-22 {
  background-color: var(--item-color-22);
}
.item-bg-color-23 {
  background-color: var(--item-color-23);
}
.item-bg-color-24 {
  background-color: var(--item-color-24);
}
.item-bg-color-25 {
  background-color: var(--item-color-25);
}
.item-bg-color-26 {
  background-color: var(--item-color-26);
}
.item-bg-color-27 {
  background-color: var(--item-color-27);
}
.item-bg-color-28 {
  background-color: var(--item-color-28);
}
.item-bg-color-29 {
  background-color: var(--item-color-29);
}
.item-bg-color-30 {
  background-color: var(--item-color-30);
}
.item-bg-color-31 {
  background-color: var(--item-color-31);
}
.item-bg-color-32 {
  background-color: var(--item-color-32);
}
.item-bg-color-33 {
  background-color: var(--item-color-33);
}
.item-bg-color-34 {
  background-color: var(--item-color-34);
}
.item-bg-color-35 {
  background-color: var(--item-color-35);
}
.item-bg-color-gray {
  background-color: var(--item-color-gray);
}
.publication-invite .btn {
  border-radius: 3px;
  background-color: initial;
  font-size: 15px;
  text-transform: uppercase;
  font-weight: bold;
  padding: 10px 18px;
  border: none;
  color: var(--modal-elem-color);
  outline: 0;
}
.publication-invite .btn:first-child {
  margin-left: auto;
}
.publication-invite .btn:not(:last-child) {
  margin-right: 10px;
}
.publication-invite .btn:hover,
.publication-invite .btn:active,
.publication-invite .btn:focus {
  background: var(--btn-bghover);
  box-shadow: none;
}
@font-face {
  font-family: 'SourceCodePro';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'SourceCodePro';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: normal;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./less/style.less"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,iCAAiC;AACnC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,8BAA8B;EAC9B,cAAc;EACd,yCAAyC;EACzC,sCAAsC;EACtC,iCAAiC;EACjC,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,YAAY;EACZ,qDAAqD;EACrD,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,2DAA2D;EAC3D,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,UAAU;EACV,YAAY;AACd;AACA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,oDAAoD;EACpD,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,0BAA0B;EAC1B,qCAAqC;EACrC,kGAAkG;AACpG;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,MAAM;EACN,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,6BAA6B;EAC7B,oDAAoD;AACtD;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,8CAA8C;AAChD;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,2DAA2D;EAC3D,wDAAwD;EACxD,mDAAmD;EACnD,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,2DAA2D;EAC3D,wDAAwD;EACxD,mDAAmD;EACnD,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,+DAA2E;EAC3E,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,+DAAkF;EAClF,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".color-red {\n  color: var(--elem-red-color);\n}\n.color-green {\n  color: green;\n}\n.color-blue {\n  color: var(--toolbtn-active-color);\n}\nbody {\n  margin: 0;\n  user-select: none;\n  overflow-x: hidden;\n}\nbody {\n  background-color: var(--bg-color);\n  color: var(--font-color);\n}\nul {\n  padding: 0;\n  margin: 0;\n}\nli {\n  display: block;\n  width: 100%;\n}\n.grey {\n  background: grey;\n}\n.green {\n  background: green;\n}\n.red {\n  background: var(--elem-red-color);\n}\n.vert-line {\n  width: 1px;\n  background: var(--vert-line-color);\n}\n.hor-line {\n  height: 1px;\n  background: var(--hor-line-color);\n}\n.light-line {\n  background: var(--message-bg-color2);\n}\n.dark-line {\n  background: #8f8f8f78;\n}\n.columns-layout {\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  height: 100%;\n}\n.rows-layout {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: calc(var(--vh) * 100);\n}\n.main {\n  position: relative;\n  flex-grow: 1;\n  height: 100%;\n}\n.row-layout {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.row-layout > div {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.modalDialog {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 99999;\n  -webkit-transition: opacity 400ms ease-in;\n  -moz-transition: opacity 400ms ease-in;\n  transition: opacity 400ms ease-in;\n  display: none;\n  pointer-events: none;\n}\n.slider {\n  display: inline-flex;\n  position: relative;\n  height: 14px;\n  margin: 10px 0;\n}\n.slider ._slider-cont {\n  height: 4px;\n  width: 100%;\n  margin: auto 0;\n  background-color: grey;\n  border-radius: 5px;\n}\n.slider ._slider-cont ._slider-wrapper {\n  height: inherit;\n  width: 100%;\n  background-color: #1e98ff;\n  border-radius: inherit;\n}\n.slider ._slider-cont ._slider-wrapper ._progress {\n  margin-left: auto;\n  height: inherit;\n  background-color: grey;\n  border-radius: inherit;\n}\n.slider ._slider-cont ._slider-wrapper ._thumb {\n  display: none;\n  height: 8px;\n  width: 4px;\n  position: absolute;\n  border-radius: 5px;\n  background-color: var(--elem-red-color);\n  transform: translate(0px, -75%);\n}\n.slider:hover ._slider-cont ._slider-wrapper ._thumb {\n  display: block;\n}\n.section-header {\n  display: flex;\n  align-items: center;\n  height: 60px;\n  min-width: 326px;\n  background-color: var(--bg-color);\n  padding: 5px;\n  border-bottom: 1px solid var(--border-bottom-section);\n  overflow: hidden;\n}\n.section-header > * {\n  margin: auto 10px;\n  overflow: hidden;\n}\n.section-header .header-back {\n  cursor: pointer;\n  font-size: 19px;\n  display: flex;\n  align-items: center;\n}\n.section-header .header-text {\n  font-size: 18px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.section-header .header-user-block {\n  display: flex;\n  cursor: pointer;\n  overflow: hidden;\n}\n.section-header .header-btns {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-left: auto;\n  font-size: 1.6em;\n}\n.section-header .header-btns .audio-call {\n  margin: auto;\n  color: var(--toolbtn-color);\n  font-size: 18px;\n}\n.section-header .header-btns .audio-call:not(.disabled):hover {\n  color: #353535;\n}\n.section-header .header-btns .close-icon {\n  height: 18px;\n}\n#modal {\n  position: absolute;\n  top: 0;\n  z-index: 20;\n}\n.btn-blue {\n  color: #fff;\n  background-color: #76a7f3;\n  border-color: #6d9ae0;\n}\n.btn-blue:hover {\n  color: #fff;\n  background-color: #6d9ae0;\n  border-color: #5e86c5;\n}\n.btn-blue:active {\n  color: #fff;\n  background-color: #5e86c5;\n  border-color: #577ab2;\n}\n.icon-wrapper .del-item {\n  display: inline-block;\n}\n.switch-group {\n  display: flex;\n}\n.switch-group > label {\n  margin: auto 0;\n  font-weight: normal;\n}\n.switch-group > label:first-child {\n  margin-right: 15px;\n}\n.non-border-input {\n  width: 90%;\n  margin: auto;\n  border: none;\n  border-radius: 0;\n  box-shadow: none !important;\n  color: var(--login-color);\n  background-color: var(--bgcolor);\n  outline: none;\n  border-bottom: 1px solid var(--border-bottom-selecteditems);\n  padding: 5px 0;\n}\n.non-border-input:focus {\n  border-bottom: 1px solid #2688c2;\n}\n.div-inout {\n  overflow-y: auto;\n  max-height: 4em;\n}\n.div-placeholder {\n  color: #999999;\n  pointer-events: none;\n  padding: 5px 0;\n  margin-bottom: -32px;\n}\n.svg-wrapper {\n  display: flex;\n}\n.fa-phone {\n  transform: rotate(90deg);\n}\n::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: #999999 !important;\n  opacity: 1;\n  /* Firefox */\n}\n:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #999999 !important;\n}\n::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #999999 !important;\n}\n* {\n  scrollbar-color: var(--scroll-bar-color) transparent;\n  scrollbar-width: thin;\n}\n*::-webkit-scrollbar {\n  width: 14px !important;\n}\n::-webkit-scrollbar-thumb {\n  border: 4px solid rgba(0, 0, 0, 0);\n  background-clip: padding-box;\n  -webkit-border-radius: 7px;\n  background-color: rgba(0, 0, 0, 0.15);\n  -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);\n}\n*::-webkit-scrollbar-thumb {\n  background-color: var(--scroll-bar-color);\n}\n::-webkit-scrollbar-corner {\n  background: transparent;\n}\n.chat-mute {\n  padding: 0 20px;\n}\n.chat-mute > p {\n  margin-bottom: 20px;\n}\n.chat-mute form {\n  display: flex;\n  flex-direction: column;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.modal-content > div {\n  border: none;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.modal-content .modal-header {\n  background-color: var(--bg-color) !important;\n}\n.modal-content .modal-header > div {\n  margin: auto 0;\n}\n.visible {\n  visibility: visible;\n}\n.user-profile {\n  position: fixed;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  z-index: 1000;\n  color: gray;\n  font-size: 18px;\n  background-color: var(--bg-color);\n}\n.user-profile .head {\n  width: 100%;\n  box-shadow: 1px 1px 1px #ccc;\n  height: calc(var(--vh) * 7);\n  display: flex;\n}\n.user-profile .head .title {\n  margin: auto;\n  font-size: 24;\n  font-weight: 600;\n}\n.user-profile .head .close {\n  margin: auto 35px auto 0;\n}\n.user-profile .wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n}\n.user-profile .wrapper .left-menu {\n  padding: 35px 0 0 28%;\n  display: flex;\n  text-align: left;\n  flex-direction: column;\n  width: 40%;\n  height: calc(var(--vh) * 93);\n  font-weight: initial;\n}\n.user-profile .wrapper .left-menu .left-menu-group {\n  font-weight: bold;\n  margin-left: 10px;\n  margin-top: 5px;\n}\n.user-profile .wrapper .left-menu .left-menu-group::not(:first-child) {\n  margin-top: 20px;\n}\n.user-profile .wrapper .left-menu .left-menu-group .group-name {\n  display: flex;\n  width: 100%;\n  padding-left: 10px;\n  border-bottom: 1px solid #ddd;\n}\n.user-profile .wrapper .left-menu .left-menu-group .list-items .item {\n  margin: 2px 0;\n  padding: 5px 10px;\n  border-radius: 10px;\n  font-weight: initial;\n}\n.user-profile .wrapper .left-menu .left-menu-group .list-items .item:hover {\n  cursor: pointer;\n  background-color: #e5f8ff;\n  color: gray;\n}\n.user-profile .wrapper .left-menu .left-menu-group .list-items .active {\n  background-color: var(--blue-bgcolor);\n  color: white;\n}\n.user-profile .wrapper .content {\n  padding: 35px 0 35px 10%;\n  color: gray;\n  display: flex;\n  flex-grow: 1;\n  height: calc(var(--vh) * 93);\n  max-width: 600px;\n}\n.fade-user-profile-enter-active,\n.fade-user-profile-leave-active {\n  transition: opacity .3s;\n}\n.fade-user-profile-enter,\n.fade-user-profile-leave-to {\n  opacity: 0;\n}\n.fade-om-journal-enter-active,\n.fade-om-journal-leave-active {\n  transition: opacity .5s;\n}\n.fade-om-journal-enter,\n.fade-om-journal-leave-to {\n  opacity: 0;\n}\n.datepickers-container {\n  z-index: 10000;\n}\n.om-settings {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n.om-settings .login {\n  margin: 5px;\n}\n.om-settings .password {\n  margin: 5px;\n}\n.om-settings .permissions {\n  margin: 5px;\n}\n.om-settings .check {\n  width: 50%;\n  margin-top: 10px;\n  border-radius: 10px;\n}\n.om-settings .check:hover {\n  background-color: lightblue;\n}\n.v--modal-overlay {\n  z-index: 1100 !important;\n}\n.v--modal {\n  -webkit-border-radius: 6px !important;\n  -moz-border-radius: 6px !important;\n  border-radius: 6px !important;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5) !important;\n}\n.scroll-msg,\n.scroll-pub {\n  transition: 0.3s;\n}\n#notice {\n  pointer-events: none;\n}\n.warning-input {\n  border-bottom: 1px solid var(--elem-red-color);\n}\n.warning-input::placeholder {\n  color: var(--elem-red-color) !important;\n}\n.warning-input:-ms-input-placeholder {\n  color: var(--elem-red-color) !important;\n}\n.warning-input::-ms-input-placeholder {\n  color: var(--elem-red-color) !important;\n}\n.draggable-menu {\n  margin: auto 0 auto auto !important;\n  width: min-content;\n  display: flex;\n  font-size: 32px;\n  color: var(--custom-textarea-color);\n}\n.draggable-menu .draggable-move {\n  cursor: move;\n  margin: auto 10px auto auto;\n  font-size: 25px;\n}\n.draggable-menu .draggable-item-menu {\n  cursor: pointer;\n  width: 30px;\n  height: 100%;\n  text-align: center;\n}\nul.list li .hor-line {\n  width: calc(100% - 68px);\n  margin-left: 68px;\n}\nul.list li:last-child .hor-line {\n  display: none;\n}\n.flip-list-move {\n  transition: transform .5s;\n}\n.no-move {\n  transition: transform 0s;\n}\n.ghost {\n  opacity: 0.5;\n  background: #c8ebfb;\n}\n.list-group {\n  min-height: 20px;\n}\n.list-group-item {\n  cursor: move;\n}\n.list-group-item i {\n  cursor: pointer;\n}\n#phone {\n  height: 100%;\n  /* left: 0px; */\n}\n.transition-phone {\n  transition: top 0.6s ease 0.1s;\n}\n.minimize-phone {\n  border-radius: 20px !important;\n}\n.phone-video-call {\n  width: 562px;\n  background-color: transparent;\n}\n#incomming-call {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  z-index: 9999;\n  -webkit-box-shadow: 0px 0px 15px 0px rgba(50, 50, 50, 0.75);\n  -moz-box-shadow: 0px 0px 15px 0px rgba(50, 50, 50, 0.75);\n  box-shadow: 0px 0px 15px 0px rgba(50, 50, 50, 0.75);\n  border-radius: 10px;\n}\n#system-notification {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  z-index: 9999;\n  -webkit-box-shadow: 0px 0px 15px 0px rgba(50, 50, 50, 0.75);\n  -moz-box-shadow: 0px 0px 15px 0px rgba(50, 50, 50, 0.75);\n  box-shadow: 0px 0px 15px 0px rgba(50, 50, 50, 0.75);\n  border-radius: 10px;\n}\n.reference-contact {\n  color: var(--ref-link-color);\n  cursor: pointer;\n}\n.reference-contact:hover {\n  color: var(--ref-link-color-hover);\n  text-decoration: underline;\n}\n.fa-spinner:not(*:root):before {\n  position: relative;\n  top: 0.03738em;\n}\nbody.mac .fa-spinner:not(*:root):before {\n  top: 0.05em;\n}\n.item-color-0 {\n  color: var(--item-color-0);\n}\n.item-color-1 {\n  color: var(--item-color-1);\n}\n.item-color-2 {\n  color: var(--item-color-2);\n}\n.item-color-3 {\n  color: var(--item-color-3);\n}\n.item-color-4 {\n  color: var(--item-color-4);\n}\n.item-color-5 {\n  color: var(--item-color-5);\n}\n.item-color-6 {\n  color: var(--item-color-6);\n}\n.item-color-7 {\n  color: var(--item-color-7);\n}\n.item-color-8 {\n  color: var(--item-color-8);\n}\n.item-color-9 {\n  color: var(--item-color-9);\n}\n.item-color-10 {\n  color: var(--item-color-10);\n}\n.item-color-11 {\n  color: var(--item-color-11);\n}\n.item-color-12 {\n  color: var(--item-color-12);\n}\n.item-color-13 {\n  color: var(--item-color-13);\n}\n.item-color-14 {\n  color: var(--item-color-14);\n}\n.item-color-15 {\n  color: var(--item-color-15);\n}\n.item-color-16 {\n  color: var(--item-color-16);\n}\n.item-color-17 {\n  color: var(--item-color-17);\n}\n.item-color-18 {\n  color: var(--item-color-18);\n}\n.item-color-19 {\n  color: var(--item-color-19);\n}\n.item-color-20 {\n  color: var(--item-color-20);\n}\n.item-color-21 {\n  color: var(--item-color-21);\n}\n.item-color-22 {\n  color: var(--item-color-22);\n}\n.item-color-23 {\n  color: var(--item-color-23);\n}\n.item-color-24 {\n  color: var(--item-color-24);\n}\n.item-color-25 {\n  color: var(--item-color-25);\n}\n.item-color-26 {\n  color: var(--item-color-26);\n}\n.item-color-27 {\n  color: var(--item-color-27);\n}\n.item-color-28 {\n  color: var(--item-color-28);\n}\n.item-color-29 {\n  color: var(--item-color-29);\n}\n.item-color-30 {\n  color: var(--item-color-30);\n}\n.item-color-31 {\n  color: var(--item-color-31);\n}\n.item-color-32 {\n  color: var(--item-color-32);\n}\n.item-color-33 {\n  color: var(--item-color-33);\n}\n.item-color-34 {\n  color: var(--item-color-34);\n}\n.item-color-35 {\n  color: var(--item-color-35);\n}\n.item-color-gray {\n  color: var(--item-color-gray);\n}\n.item-bg-color-0 {\n  background-color: var(--item-color-0);\n}\n.item-bg-color-1 {\n  background-color: var(--item-color-1);\n}\n.item-bg-color-2 {\n  background-color: var(--item-color-2);\n}\n.item-bg-color-3 {\n  background-color: var(--item-color-3);\n}\n.item-bg-color-4 {\n  background-color: var(--item-color-4);\n}\n.item-bg-color-5 {\n  background-color: var(--item-color-5);\n}\n.item-bg-color-6 {\n  background-color: var(--item-color-6);\n}\n.item-bg-color-7 {\n  background-color: var(--item-color-7);\n}\n.item-bg-color-8 {\n  background-color: var(--item-color-8);\n}\n.item-bg-color-9 {\n  background-color: var(--item-color-9);\n}\n.item-bg-color-10 {\n  background-color: var(--item-color-10);\n}\n.item-bg-color-11 {\n  background-color: var(--item-color-11);\n}\n.item-bg-color-12 {\n  background-color: var(--item-color-12);\n}\n.item-bg-color-13 {\n  background-color: var(--item-color-13);\n}\n.item-bg-color-14 {\n  background-color: var(--item-color-14);\n}\n.item-bg-color-15 {\n  background-color: var(--item-color-15);\n}\n.item-bg-color-16 {\n  background-color: var(--item-color-16);\n}\n.item-bg-color-17 {\n  background-color: var(--item-color-17);\n}\n.item-bg-color-18 {\n  background-color: var(--item-color-18);\n}\n.item-bg-color-19 {\n  background-color: var(--item-color-19);\n}\n.item-bg-color-20 {\n  background-color: var(--item-color-20);\n}\n.item-bg-color-21 {\n  background-color: var(--item-color-21);\n}\n.item-bg-color-22 {\n  background-color: var(--item-color-22);\n}\n.item-bg-color-23 {\n  background-color: var(--item-color-23);\n}\n.item-bg-color-24 {\n  background-color: var(--item-color-24);\n}\n.item-bg-color-25 {\n  background-color: var(--item-color-25);\n}\n.item-bg-color-26 {\n  background-color: var(--item-color-26);\n}\n.item-bg-color-27 {\n  background-color: var(--item-color-27);\n}\n.item-bg-color-28 {\n  background-color: var(--item-color-28);\n}\n.item-bg-color-29 {\n  background-color: var(--item-color-29);\n}\n.item-bg-color-30 {\n  background-color: var(--item-color-30);\n}\n.item-bg-color-31 {\n  background-color: var(--item-color-31);\n}\n.item-bg-color-32 {\n  background-color: var(--item-color-32);\n}\n.item-bg-color-33 {\n  background-color: var(--item-color-33);\n}\n.item-bg-color-34 {\n  background-color: var(--item-color-34);\n}\n.item-bg-color-35 {\n  background-color: var(--item-color-35);\n}\n.item-bg-color-gray {\n  background-color: var(--item-color-gray);\n}\n.publication-invite .btn {\n  border-radius: 3px;\n  background-color: initial;\n  font-size: 15px;\n  text-transform: uppercase;\n  font-weight: bold;\n  padding: 10px 18px;\n  border: none;\n  color: var(--modal-elem-color);\n  outline: 0;\n}\n.publication-invite .btn:first-child {\n  margin-left: auto;\n}\n.publication-invite .btn:not(:last-child) {\n  margin-right: 10px;\n}\n.publication-invite .btn:hover,\n.publication-invite .btn:active,\n.publication-invite .btn:focus {\n  background: var(--btn-bghover);\n  box-shadow: none;\n}\n@font-face {\n  font-family: 'SourceCodePro';\n  src: url('../fonts/SourceCodePro-VariableFont_wght.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'SourceCodePro';\n  src: url('../fonts/SourceCodePro-Italic-VariableFont_wght.ttf') format('truetype');\n  font-weight: normal;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
